// @flow
import { CategoriasEnlacesActionTypes } from './constants';

type CategoriasEnlacesAction = { type: string, payload: {} | string };

// common success
export const categoriasEnlacesApiResponseSuccess = (actionType: string, data: any): CategoriasEnlacesAction => ({
    type: CategoriasEnlacesActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const categoriasEnlacesApiResponseError = (actionType: string, error: string): CategoriasEnlacesAction => ({
    type: CategoriasEnlacesActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getCategoriaEnlaces = (id: string): CategoriasEnlacesAction => ({
    type: CategoriasEnlacesActionTypes.GET_CATEGORIA_ENLACES,
    payload: { id },
});

export const addCategoriaEnlaces = (categoriaEnlaces:any):CategoriasEnlacesAction=>({
    type:CategoriasEnlacesActionTypes.ADD_CATEGORIA_ENLACES,
    payload:categoriaEnlaces
})
export const updateCategoriaEnlaces = (categoriaEnlaces:any):CategoriasEnlacesAction=>({
    type:CategoriasEnlacesActionTypes.UPDATE_CATEGORIA_ENLACES,
    payload:categoriaEnlaces
})
export const deleteCategoriaEnlaces = (id:string):CategoriasEnlacesAction=>({
    type:CategoriasEnlacesActionTypes.DELETE_CATEGORIA_ENLACES,
    payload:{id}
})

export const listCategoriasEnlaces = (params:any): CategoriasEnlacesAction => ({
    type: CategoriasEnlacesActionTypes.LIST_CATEGORIAS_ENLACES,
    payload: params,
});


export const resetCategoriasEnlaces = (): CategoriasEnlacesAction => ({
    type: CategoriasEnlacesActionTypes.RESET,
    payload: {},
});

